<template>
  <v-container fluid grid-list-md>
    <v-card class="mb-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">PO监控</h3>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="searchSI()" v-permit.SHARP_PO_SEARCH>検索SI</v-btn>
        <v-btn @click="searchSEM()" v-permit.SHARP_PO_SEARCH>検索SEM</v-btn>
      </v-card-actions>
    </v-card>
    <v-layout row>
      <v-flex xs4>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="fileHeaders"
              :items="files"
              :pagination.sync="filePagination"
              :rows-per-page-items="[10]"
              :total-items="filePagination.totalItems"
              item-key="id"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.createDate }}</td>
                <td>
                  <v-chip
                    :key="c[0]"
                    @click="show(props.item.id, c[0])"
                    outline
                    small
                    v-for="c in props.item.summary"
                  >
                    <strong>{{c[0]||'All'}}:</strong>
                    <span>{{c[1]}}</span>
                  </v-chip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs8>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="results"
              :pagination.sync="pagination"
              :rows-per-page-items="[10]"
              :total-items="pagination.totalItems"
              item-key="id"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.poNo }}</td>
                <td>{{ props.item.handleFlag }}</td>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.errorMsg }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      type: 'SI',
      id: null,
      status: null,
      fileHeaders: [
        { text: 'id', value: 'id', sortable: false },
        { text: 'createDate', value: 'createDate', sortable: false },
        { text: 'summary', value: 'summary', sortable: false }
      ],
      filePagination: {
        rowsPerPage: 10,
        page: 1
      },
      headers: [
        { text: this.$t('app.labels.poNo'), value: 'poNo', sortable: false },
        { text: 'Handle Flag', value: 'handleFlag', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Message', value: 'errorMsg', sortable: false }
      ],
      pagination: {
        rowsPerPage: 10
      },
      files: [],
      results: []
    }
  },
  methods: {
    loadFiles() {
      this.$http
        .get(`/purchase-orders/monitor/files/${this.type}`, {
          params: {
            page: this.filePagination.page - 1,
            size: 10,
            sort: 'id,desc'
          }
        })
        .then(res => {
          this.filePagination.page = res.data.number + 1
          this.filePagination.rowsPerPage = res.data.size
          this.filePagination.totalItems = res.data.totalElements
          this.files = res.data.content
        })
    },
    show(id, status) {
      this.id = id
      this.status = status
      this.loadData()
    },
    loadData() {
      this.$http
        .get(`/purchase-orders/monitor/${this.type}`, {
          params: {
            batchNo: this.id,
            status: this.status,
            page: this.pagination.page - 1,
            size: 10,
            sort: 'b2bMeta.batchSeq,asc'
          }
        })
        .then(res => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
        })
    },
    searchSI() {
      this.type = 'SI'
      this.loadFiles()
    },
    searchSEM() {
      this.type = 'SEM'
      this.loadFiles()
    }
  },

  watch: {
    filePagination() {
      this.loadFiles()
    },
    pagination() {
      this.loadData()
    }
  }
}
</script>
